import { render, staticRenderFns } from "./ShapeBrand.vue?vue&type=template&id=dfc82424"
import script from "./ShapeBrand.vue?vue&type=script&lang=js"
export * from "./ShapeBrand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports